export const detailEnLocale = {
  'details.hero.button': 'More info',
  'details.hero.share': 'Share with friends',

  'details.detail.title': 'Details',
  'details.detail.date': 'Date',
  'details.detail.openDoors': 'Open doors',
  'details.detail.startEvent': 'Start event',

  'details.fees.title': 'Includes service fees',
  'details.fees.button': 'Restrictions',

  'details.prices.title': 'Prices',

  'details.information.title': 'Event information',

  'details.additionalInformation.title': 'Additional information',
  'details.additionalInformation.button':
    'Send a message to the event organizer',

  'details.videos.title': 'Videos',
  'details.artists.title': 'Artists',

  'details.fixedSection.button': 'Find tickets',

  'details.detail.venue': 'Venue',
  'details.detail.city': 'City',
  'details.detail.duration': 'Duration',
  'details.and': 'and'
} as const;

export const detailEsLocale = {
  'details.hero.button': 'Detalles',
  'details.hero.share': 'Compartir con amigos',

  'details.detail.title': 'Detalles',
  'details.detail.date': 'Fecha',
  'details.detail.openDoors': 'Puertas abren',
  'details.detail.startEvent': 'Inicio del evento',

  'details.fees.title': 'Cargo por servicios',
  'details.fees.button': 'Restricciones',

  'details.prices.title': 'Precios',

  'details.information.title': 'Información del evento',

  'details.additionalInformation.title': '¿Tienes preguntas adicionales?',
  'details.additionalInformation.button':
    'Envía un mensaje al organizador del evento',
  'details.videos.title': 'Videos',
  'details.artists.title': 'Artistas',

  'details.fixedSection.button': 'Comprar',

  'details.detail.venue': 'Lugar',
  'details.detail.city': 'Ciudad',
  'details.detail.duration': 'Duración',
  'details.and': 'y'
} as const;
